module.exports = __webpack_public_path__ + "static/media/dsr_checklist.0602f48c.svg";